import { render, staticRenderFns } from "./StartupRegistrationHelp.vue?vue&type=template&id=40a33f68&scoped=true"
import script from "./StartupRegistrationHelp.vue?vue&type=script&lang=js"
export * from "./StartupRegistrationHelp.vue?vue&type=script&lang=js"
import style0 from "./StartupRegistrationHelp.vue?vue&type=style&index=0&id=40a33f68&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40a33f68",
  null
  
)

export default component.exports